@let valueNotChanged = initialSubdivisionId() === releaseCityControl.value?.id;
@let isDisabled =
  (cityState() === 'none' && releaseCityControl.value === null) ||
  (cityState() === 'manually' && valueNotChanged);
<div class="flex flex-col h-full">
  <x-form-picker
    [formControl]="releaseCityControl"
    xAttachSubdivisions
    [contractorId]="contractorId()"
    [initialItemId]="initialSubdivisionId()"
  ></x-form-picker>

  @if (cityState() === 'none') {
    <p class="text-red-600 text-base mt-3 font-medium">
      {{ 'request_form.summary.release_city_none' | translate }}
    </p>
  }

  @if (cityState() === 'manually') {
    <p class="text-amber-600 text-base mt-3">
      {{ 'request_form.summary.release_city_manually' | translate }}
    </p>
  }

  @if (cityState() === 'auto' && valueNotChanged) {
    <p class="text-amber-600 text-base mt-3">
      {{ 'request_form.summary.release_city_auto' | translate }}
    </p>
  }

  <button
    tuiButton
    type="button"
    appearance="primary"
    class="w-full mt-3"
    (click)="setSubdivisionIdManually()"
    [disabled]="isDisabled"
  >
    {{
      (cityState() === 'auto'
        ? 'request_form.summary.release_city_confirm'
        : 'request_form.summary.release_city_change'
      ) | translate
    }}
  </button>
</div>
